import publicUrl from './publicUrl';



export default publicUrl(() => '/page-not-found');
